import { render, staticRenderFns } from "./AgencyResponses.vue?vue&type=template&id=6b0e07f5&scoped=true"
import script from "./AgencyResponses.vue?vue&type=script&lang=js"
export * from "./AgencyResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e07f5",
  null
  
)

export default component.exports